import { z } from "zod";

/**
 * Payload carried in the HS256 session JWT.
 *
 * Field names are deliberately short (sid/uid) to keep the encoded cookie
 * below typical header size limits — see specs/phase-2/03-jwt-utils.md.
 *  - sid: KV session key (so sessions can be invalidated server-side)
 *  - uid: users.id
 *  - iat / exp: seconds since epoch (JWT standard — NOT milliseconds)
 */
export const JwtPayloadSchema = z.object({
  sid: z.string().uuid(),
  uid: z.string().uuid(),
  iat: z.number().int().nonnegative(),
  exp: z.number().int().positive(),
});
export type JwtPayload = z.infer<typeof JwtPayloadSchema>;
